export class DomainData {
  data: Record<string, any>;
  status: number;

  constructor(params: Record<string, any>) {
    this.data = params.data;
    this.status = params.status;
  }
}
